// SideImage.js
import React from "react";
import { Container, Typography, Hidden } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import styles from "./loginSideImageStyles";

const LoginSideImage = () => {
  return (
    <Hidden mdDown={true}>
      <Grid xs={6} md={6}>
        <Container style={styles.imageContainer}>
          <Typography variant="h4" sx={styles.imageTitle} gutterBottom>
            Siempre la mejor opción
          </Typography>
          <Typography variant="h6" sx={styles.imageSubtitle} gutterBottom>
            Rapida, segura y eficiente.
          </Typography>
        </Container>
      </Grid>
    </Hidden>
  );
};

export default LoginSideImage;
